import { featureFlagClient } from '@trello/feature-flag-client';
import { Analytics } from '@trello/atlassian-analytics';
import { sendErrorEvent } from '@trello/error-reporting';
import { MessagesFromServiceWorker } from '@trello/service-worker';
import { handleStorageError } from 'app/scripts/init/handleStorageError';

const handleServiceWorkerMessage = (event: MessagesFromServiceWorker) => {
  console.log('received event from service worker', event);
  switch (event.type) {
    case 'QUOTA_EXCEEDED': {
      const { error, key } = event;
      console.warn(error);
      handleStorageError({ error, key, isFromServiceWorker: true });
      break;
    }
    default: {
      console.warn('Unrecognized message from service worker', event);
    }
  }
};

const unregisterWorkers = () => {
  // Unsubscribe to messages from the worker
  navigator.serviceWorker.onmessage = () => {};

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length > 0) {
      console.log(`[SERVICE WORKER] Unregistering`);
      for (let i = 0; i < registrations.length; i++) {
        Analytics.sendOperationalEvent({
          actionSubject: 'serviceWorker',
          action: 'unregistered',
          source: 'appStartup',
        });
        registrations[i].unregister();
      }
    }
  });
};

const registerWorker = () => {
  // subscribe to messages from the worker
  navigator.serviceWorker.onmessage = (event) =>
    handleServiceWorkerMessage(event.data);

  navigator.serviceWorker
    .register('/service-worker.js')
    .then(() => {
      console.log('[SERVICE WORKER] Registered');
      Analytics.sendOperationalEvent({
        actionSubject: 'serviceWorker',
        action: 'registered',
        source: 'appStartup',
      });
    })
    .catch((registrationError) => {
      console.log('[SERVICE WORKER] Registration failed');
      sendErrorEvent(registrationError);
      unregisterWorkers();
    });
};

export const registerOrUnregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    const isServiceWorkerEnabled = featureFlagClient.get(
      'fep.service_worker',
      false,
    );

    featureFlagClient.on('fep.service_worker', false, (newValue) => {
      if (newValue === false) {
        unregisterWorkers();
      } else {
        registerWorker();
      }
    });

    if (isServiceWorkerEnabled) {
      registerWorker();
    } else {
      unregisterWorkers();
    }
  }
};
